module.exports = __webpack_public_path__ + "static/img/bushuli1.6808afd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rppghealth/bushuli1.png
// module id = 4KFy
// module chunks = 5